import { MinsterDatePickerComponent } from "../ui-components/minster-date-picker/minster-date-picker.component";
import { MinsterTimePickerComponent } from "../ui-components/minster-time-picker/minster-time-picker.component";
import { MinsterSelectComponent } from "../ui-components/minster-select/minster-select.component";
import { MinsterInputComponent } from "../ui-components/minster-input/minster-input.component";
import { MinsterCardComponent } from '../ui-components/minster-card/minster-card.component';
import { ControlContainer, FormsModule, NgForm, NgModelGroup } from '@angular/forms';
import { ScreenBaseComponent } from '../screen-base/screen-base.component';
import { InputType, ScreenType } from '../../models/enums.models';
import { ClaimsService } from '../../services/claims.service';
import { StateService } from '../../services/state.service';
import { MatButtonModule } from '@angular/material/button';
import { Component, ViewChild } from '@angular/core';
import { Accident } from '../../models/claim.model';
import { LookUp } from '../../models/look-up.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'app-your-accident-time-location',
    standalone: true,
    imports: [MinsterDatePickerComponent, MinsterTimePickerComponent, MinsterSelectComponent,
        FormsModule, MinsterCardComponent, MatButtonModule, MinsterInputComponent],
    templateUrl: './your-accident-time-location.component.html',
    styleUrl: './your-accident-time-location.component.css',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})

export class YourAccidentTimeLocationComponent extends ScreenBaseComponent {
    @ViewChild(NgModelGroup) _formGroup: NgModelGroup | undefined;

    _accident: Accident;
    _accidentCountries: LookUp[];
    _inputTypes = InputType;
    _readonly: boolean = false;

    constructor(stateService: StateService, router: Router, toastr: ToastrService, claimService: ClaimsService) {
        super(router, ScreenType.YourAccidentTimeLocation, toastr, stateService, claimService);

        this._readonly = stateService.formIsSubmitted;
        this._accident = stateService.claim?.accident!;
        this._accidentCountries = stateService.lookUps!.lookUpDictionary['AccidentCountryDigitalOnBoarding'];
    }

    override isScreenValid(): boolean {
        return this.stateService.getFormValidationErrorsExcludeRequired(this._formGroup!.control) == 0;
    }

    override onNext(): void {
        if(this._readonly){
            super.onNext();
            return;
        }
        if (this._formGroup && this._formGroup.invalid) {
            let hasErrors = false;

            Object.keys(this._formGroup.control.controls).forEach((key) => {
                const control = this._formGroup!.control.get(key);

                if (control) {
                    const errors = control.errors;

                    if (errors) {
                        const hasOnlyRequiredError = Object.keys(errors).length === 1 && errors['required'];

                        if (this.stateService.formIsSubmitted) {
                            hasErrors = true;
                        }
                        else if (!hasOnlyRequiredError) {
                            hasErrors = true;
                        }
                    }

                    control.markAsTouched();
                    control.markAsDirty();
                    control.updateValueAndValidity();
                }
            });

            if (hasErrors) {
                this.toastr.warning('Please fix the form errors before proceeding.');
                this.stateService.enableSaving = false;
                return;
            }
        }

        if (this.stateService.formIsSubmitted && this._formGroup!.invalid) {
            this.toastr.warning('Please fix the required fields before proceeding.');
            this.stateService.enableSaving = false;
            return;
        }

        this.stateService.enableSaving = this.hasStateChanged();

        super.onNext();
    }
}
